<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/chinees/Asset 1.png" alt="">
    <img draggable="false" @click="goToIntro()" class="clickable" id="chinees_start_btn" src="./../../assets/images/Asset 30.png" alt="">
    <img draggable="false" id="obj_1" src="./../../assets/images/chinees/Asset 3.png" alt="">
    <img draggable="false" id="obj_2" src="./../../assets/images/chinees/Asset 5.png" alt="">
    <img draggable="false" id="obj_3" src="./../../assets/images/chinees/Asset 4.png" alt="">
    <img draggable="false" id="obj_4" src="./../../assets/images/chinees/Asset 6.png" alt="">

    <span id="chinees_start_text">Chinees nieuw jaar</span>
  </span>
</template>

<script>
export default {
  name: "ChineesStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToStart() {
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: false,
      });
      this.$router.push('/start');
    },
    goToIntro() {
      this.$router.push('/chinees/intro');
    },
    
  },

  computed: {}
};
</script>

<style>
  #chinees_start_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 3%;
    width: 40%;
    left: 30%;
    color: #cb1916;
    font-size: 4vw;
    text-align: center;
  }
  #chinees_start_btn {
    position: absolute;
    margin-top: 35%;
    left: 42.5%;
    width: 15%;
  }
  #obj_1 {
    position: absolute;
    margin-top: -2%;
    left: 10.5%;
    width: 8.5%;
  }
  #obj_2 {
    position: absolute;
    margin-top: -2%;
    left: 20%;
    width: 15%;
  }
  #obj_3 {
    position: absolute;
    margin-top: -2%;
    left: 65.5%;
    width: 15%;
  }
  #obj_4 {
    position: absolute;
    margin-top: -2%;
    left: 81%;
    width: 9%;
  }
</style>


